import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import SuppliersApi from "../../common/Apis/SuppliersApi";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const Suppliers = () => {
  const navigate = useNavigate();
  const [formadd2] = Form.useForm();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [Suppliers, setSuppliers] = React.useState([]);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    SuppliersApi.Listsuppliers(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setSuppliers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    SuppliersApi.Listsuppliers(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setSuppliers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getSuppliers = useCallback(() => {
    SuppliersApi.Listsuppliers(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setSuppliers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getSuppliers();
    fetchFilterDepartment();
  }, [getSuppliers, PageLoading]);


  const handleRemovefilterSupplier = (FilterSuppliersIndex) => {
    const newfilterSuppliers = [...filterSuppliers];
    newfilterSuppliers.splice(FilterSuppliersIndex, 1);
    setFilterSuppliers(newfilterSuppliers);
    if (FilterSuppliersIndex == 0) {
      getSuppliers();
    }
  };
  const handleClear = () => {
    getSuppliers();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterSuppliers([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterSuppliers, setFilterSuppliers] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterSuppliers = () => {
    setFilterSuppliers([
      ...filterSuppliers,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleDeleteSupplier = (SupplierID) => {
    SuppliersApi.DeleteSupplier(SupplierID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getSuppliers();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterSuppliers
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa("componentCode=SUPPLIER&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setSuppliers(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (FilterSuppliersIndex, value) => {
    const newfilterSuppliers = [...filterSuppliers];
    newfilterSuppliers[FilterSuppliersIndex].title = value;
    setFilterSuppliers(newfilterSuppliers);
  };
  const handleChangeAnswertype = (FilterSuppliersIndex, value) => {
    const newfilterSuppliers = [...filterSuppliers];
    newfilterSuppliers[FilterSuppliersIndex].answerType = value;
    setFilterSuppliers(newfilterSuppliers);

    const fieldName = 'name' + FilterSuppliersIndex;
    const fieldName2 = 'nameto' + FilterSuppliersIndex;
    formadd2.setFieldsValue({
      [fieldName]: null,
      [fieldName2]: null,
    });

  };

  const handleChangeAnswertypeFilter = (FiltergetproductionIndex, value) => {
    const newfilterProduction = [...filterSuppliers];
    newfilterProduction[FiltergetproductionIndex].answerType = '=';
    newfilterProduction[FiltergetproductionIndex].name = value;
    setFilterSuppliers(newfilterProduction);
  };


  const handleChangename = (FilterSuppliersIndex, value) => {
    const newfilterSuppliers = [...filterSuppliers];
    newfilterSuppliers[FilterSuppliersIndex].name = value;
    setFilterSuppliers(newfilterSuppliers);
  };

  const paginatedData = Suppliers;
  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item.id} className="text-center">
          <td style={{ width: "22%" }} className="pt-3">
            {item?.supplierName}
          </td>
          <td style={{ width: "20%" }} className="pt-3">
            {item?.address === null ? "" : item?.address.slice(0, 55)}
          </td>
          <td style={{ width: "20%" }} className="pt-3">
            {item?.institutionDTO?.institutionName}
          </td>
          <td style={{ width: "25%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/suppliers/edit-Supplier?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_SUPPLIER'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Supplier ?"
                okText="Yes"
                placement="topRight"
                className="w-100"
                onConfirm={() => handleDeleteSupplier(item.id)}
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_SUPPLIER'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={4} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "7%", marginBottom:"10px" }}
            />
            <br />
            <Button
              type="primary"
              onClick={() => { navigate("/masters/suppliers/add-Supplier") }}
              // href={"/masters/suppliers/add-Supplier"}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_SUPPLIER'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add Supplier
            </Button>
          </td>
        </tr>
      );
    }
  };

  const [FilterDepartment, setFilterDepartment] = useState([]);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);


  const fetchFilterDepartment = async () => {
    try {
      DepartmentsApi.ListDepartments(page, 10)
        .then((response) => {
          setTotalPageNew(response.totalPages);
          setFilterDepartment(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

          setPage(prevPage => prevPage + 1);

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
    } finally {
    }
  };
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchFilterDepartment();
      }
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            form={formadd2}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterSuppliers.map((input, filterSuppliersIndex) => (
                    <div key={filterSuppliersIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterSuppliersIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterSuppliersIndex, value)
                              }
                              options={[
                                {
                                  value: "supplierName",
                                  label: "Supplier Name",
                                },
                                { value: "address", label: "Address" },
                                {
                                  value: "institution.id",
                                  label: "Department",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        {filterSuppliers[filterSuppliersIndex].title === "institution.id" ? (
                          <>
                            <Col lg={6} md={6} className="px-1">
                              <Form.Item
                                name={`nameto${filterSuppliersIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select Start Date.",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  className="control-Select mb-1"
                                  placeholder="Select Department"
                                  onPopupScroll={handleScroll}
                                  onChange={(value) =>
                                    handleChangeAnswertypeFilter(
                                      filterSuppliersIndex,
                                      value
                                    )
                                  }
                                  filterOption={(input, option) =>
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase())) ||
                                    (option.props.children && option.props.children.toString().toLowerCase().includes(input.toLowerCase()))
                                  }
                                >
                                  {FilterDepartment.map((option, index) => (
                                    <Select.Option key={option.id} value={option.id}>
                                      {option?.institutionName}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col lg={4} md={4} className="px-1">
                              <Form.Item
                                name={`type${filterSuppliersIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please Select type.",
                                  },
                                ]}
                              >
                                <Select
                                  className="control-Select mb-1"
                                  placeholder="Condition"
                                  onChange={(value) =>
                                    handleChangeAnswertype(
                                      filterSuppliersIndex,
                                      value
                                    )
                                  }
                                  options={[
                                    { value: "%", label: "Matches with" },
                                    {
                                      value: "=",
                                      label: "Equals to",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}

                        {filterSuppliers[filterSuppliersIndex].title === "institution.id" ? (
                          <>

                          </>
                        ) : (
                          <>
                            <Col span={5}>
                              <Form.Item
                                name={`name${filterSuppliersIndex}`}
                                className="text-lable"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Text.",
                                  },
                                ]}
                              >
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    handleChangename(
                                      filterSuppliersIndex,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Text"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </>
                        )}



                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterSuppliersIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterSuppliers}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterSupplier(
                                      filterSuppliersIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>

        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  // <div className="col-xl-12 col-lg-7 col-md-12 px-0 ">
                  //   <Button
                  //     className={decodedToken?.permissions?.some(
                  //       (permission) => permission?.authority === 'ADD_SUPPLIER'
                  //     ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                  //     href={"/masters/suppliers/add-Supplier"}
                  //   >
                  //     Add new
                  //   </Button>
                  // </div>
                  <Button
              type="primary"
              onClick={() => { navigate("/masters/suppliers/add-Supplier") }}
              // href={"/masters/suppliers/add-Supplier"}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_SUPPLIER'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add New Supplier
            </Button>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>

            <table className="table users-table">
              <thead>
                <tr>
                  <th>Supplier Name</th>
                  <th>Address</th>
                  <th>Department</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Suppliers;
